import { IRelatorioAM } from "@/interfaces/IRelatorioAM";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "..";

interface RelatorioAMState {
  items: IRelatorioAM[];
}

const initialState: RelatorioAMState = {
  items: [],
};

const relatorioAMSlice = createSlice({
  name: "RELATORIO_AM",
  initialState,
  reducers: {
    add: (state, action: PayloadAction<{ item: IRelatorioAM }>) => {
      const { item } = action.payload;
      state.items.push({ ...item, offlineId: item.offlineId || Date.now() });
    },
    remove: (state, action: PayloadAction<{ offlineId: number }>) => {
      state.items = state.items.filter(
        (item) => item.offlineId !== action.payload.offlineId
      );
    },
    update: (state, action: PayloadAction<{ item: IRelatorioAM }>) => {
      const index = state.items.findIndex(
        (item) => item.offlineId === action.payload.item.offlineId
      );
      state.items[index] = action.payload.item;
    },
  },
});

export default relatorioAMSlice.reducer;

export const getRelatoriosAM = (state: RootState) => {
  const listaInvertida = state.relatorioAM.items.map((_, ind, lista) => {
    return lista[lista.length - ind - 1];
  });

  return listaInvertida;
};
